<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ 'overview.title' | translate }}</h2>
      <p class="page-sub">{{ 'overview.subtitle' | translate:{month: monthLabel} }}</p>
    </div>
    <span class="spacer"></span>
    <mat-form-field appearance="outline" class="month-picker">
      <mat-label>{{ 'overview.month' | translate }}</mat-label>
      <mat-select [value]="month" (selectionChange)="onMonthChange($event.value)">
        <mat-option *ngFor="let m of months" [value]="m.value">{{ monthOptionLabel(m.value) }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="state" *ngIf="loading">Loading…</div>
  <div class="state error" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!loading && !error && summary">
    <div class="stat-grid">
      <div class="stat">
        <div class="stat-label">{{ 'overview.employees' | translate }}</div>
        <div class="stat-value">{{ summary.employeeCount }}</div>
        <div class="stat-foot">{{ 'overview.activeInactive' | translate:{active: summary.activeCount, inactive: summary.inactiveCount} }}</div>
      </div>
      <div class="stat">
        <div class="stat-label">{{ 'overview.purchases' | translate }}</div>
        <div class="stat-value">{{ summary.purchaseCount }}</div>
        <div class="stat-foot">{{ 'overview.paidByEmployees' | translate:{amount: kr(summary.purchaseTotal)} }}</div>
      </div>
      <div class="stat">
        <div class="stat-label">{{ 'overview.yourSubsidy' | translate }}</div>
        <div class="stat-value">kr {{ kr(summary.subsidyExVAT) }}</div>
        <div class="stat-foot">{{ 'overview.subsidyFoot' | translate }}</div>
      </div>
      <div class="stat">
        <div class="stat-label">{{ 'overview.creditOnAccounts' | translate }}</div>
        <div class="stat-value">kr {{ kr(summary.creditOutstanding) }}</div>
        <div class="stat-foot">{{ 'overview.creditFoot' | translate }}</div>
      </div>
    </div>

    <div class="notice" *ngIf="summary.reportError">
      <mat-icon>info</mat-icon>
      <span>{{ summary.reportError }} {{ 'overview.reportErrorSuffix' | translate }}</span>
    </div>

    <h3 class="section-title">{{ 'overview.yourGroups' | translate }}</h3>
    <p class="page-sub">
      {{ 'overview.groupsIntro' | translate }}
    </p>

    <div class="card-grid">
      <div class="group-card" *ngFor="let g of groups">
        <div class="group-name">{{ g.name }}</div>
        <div class="group-detail" *ngIf="g.type === 'subsidy'">
          <span class="pill pill-green">{{ 'overview.subsidyPct' | translate:{pct: g.subsidy} }}</span>
          <span class="group-note">{{ 'overview.subsidyNote' | translate:{pct: g.subsidy} }}</span>
        </div>
        <div class="group-detail" *ngIf="g.type === 'credit'">
          <span class="pill pill-blue">{{ 'overview.creditPill' | translate:{amount: kr(g.monthlyCredit)} }}</span>
          <span class="group-note">{{ 'overview.creditNote' | translate }}</span>
        </div>
        <div class="group-detail" *ngIf="g.type === 'none'">
          <span class="pill">{{ 'overview.noSubsidyPill' | translate }}</span>
          <span class="group-note">{{ 'overview.noSubsidyNote' | translate }}</span>
        </div>
      </div>
      <div class="state" *ngIf="!groups.length">
        {{ 'overview.noGroups' | translate }}
      </div>
    </div>
  </ng-container>
</div>
